export const SUCCESS_ROLE="SUCCESS_ROLE";
export const FAILED_ROLE="FAILED_ROLE";
export const REQUST_ROLE="REQUST_ROLE";
